import { Stack } from '@mui/material';
import { FC, useMemo } from 'react';

import { B2bInvestorProfileSicavGridAddRowButton } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/components/B2bInvestorProfileSicavGridAddRowButton/B2bInvestorProfileSicavGridAddRowButton';
import { B2bInvestorProfileSicavGridContainer } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/components/B2bInvestorProfileSicavGridContainer/B2bInvestorProfileSicavGridContainer';
import { B2bInvestorProfileSicavGridRow } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/components/B2bInvestorProfileSicavGridRow/B2bInvestorProfileSicavGridRow';
import { useB2bSicavGridLogic } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/hooks/useB2bSicavGridLogic';

export const B2bInvestorProfileSicavGrid: FC = () => {
  const { currentGrid, addRow: handleAddRow, removeRow: handleRemoveRow } = useB2bSicavGridLogic();

  const GridContent = useMemo(
    () =>
      currentGrid.map((row, index) => (
        <B2bInvestorProfileSicavGridRow
          index={index}
          year={row.year}
          isLastRow={index === currentGrid.length - 1}
          onRemove={handleRemoveRow}
        />
      )),
    [currentGrid, handleRemoveRow],
  );

  if (currentGrid.length === 0) {
    return null;
  }

  return (
    <Stack direction="column" width="100%" spacing={3}>
      <B2bInvestorProfileSicavGridContainer content={GridContent} />
      <B2bInvestorProfileSicavGridAddRowButton
        onAddRow={handleAddRow}
        totalRows={currentGrid.length}
        testId="BoExternalB2bInvestorProfileSicavGrid_AddRowButton"
      />
    </Stack>
  );
};
